module.exports = __webpack_public_path__ + "static/media/angellist.01961d5a.svg";